import { render, staticRenderFns } from "./DateSelector.vue?vue&type=template&id=8ddd4fde&scoped=true"
import script from "./DateSelector.vue?vue&type=script&lang=js"
export * from "./DateSelector.vue?vue&type=script&lang=js"
import style0 from "./DateSelector.vue?vue&type=style&index=0&id=8ddd4fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddd4fde",
  null
  
)

export default component.exports